import React, { useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import { IFlight, IGroundEvent } from "@vmosolutions/oc-interfaces";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { DialogActions, Grid, useTheme } from "@mui/material";
import { FlightChipCollection } from "src/components/Flights/FlightChip";
import { ModalTitle, ModalButton, ModalMessage } from "../DialogModalComponents";
import { EventModalTypes } from "../DialogModalWrapper";
import { isFlight } from "src/redux/reducers/FlightTimelineReducer";
import { ShortCodeAssignment } from "./ShortCodeAssignment/ShortCodeAssignment";
import { IShortCodeChip } from "../../ShortCodes/ShortCodeChip";
import { openWindow } from "src/redux/actions/Mosaic.Actions";
import { setSelectedEvents } from "src/redux/actions/flights/FlightTimeline.Actions";
import { DialogModalStyles } from "../DialogModalWrapper";

/**
 * Modal appears only when 1 flight is slected and the ground turnback button is selected
 * gathers user info from via modal and dispatches an API call to update flight and create a ground event
 */

interface IAssignFlightsToPairingModalProps {
  isOpen: boolean;
  handleClose: (value: boolean) => void;
  setActiveEventModal: (EventModalTypes: EventModalTypes) => void;
}

export const AssignFlightsToPairingModal = (props: IAssignFlightsToPairingModalProps): JSX.Element => {
  const { isOpen, handleClose, setActiveEventModal } = props;

  const dispatch = useDispatch();
  const theme = useTheme();
  const [selectedShortCode, setSelectedShortCode] = useState<IShortCodeChip>(null);

  const selectedEvents = useSelector((state: IRootState) => state.timelineFlights.selectedEvents);
  const selectedFlights: IFlight[] = React.useMemo(() => {
    return selectedEvents.filter((event: IFlight | IGroundEvent) => isFlight(event));
  }, [selectedEvents]);

  const typeFlight: boolean = selectedFlights.length > 0 ? true : false;

  const handleCancel = (): void => {
    handleClose(false);
    setActiveEventModal(EventModalTypes.None);
  };

  const handleAssignToPairing = (): void => {
    dispatch(
      openWindow(
        "Edit Pairing",
        "PairingEditorWindow",
        [],
        {
          pairingId: selectedShortCode.itemId,
          flights: selectedFlights,
        },
        null,
        true
      )
    );
    setActiveEventModal(EventModalTypes.None);
    //unselect flights after creating the pairing
    dispatch(setSelectedEvents([]));
  };

  if (isOpen && selectedEvents.length > 0) {
    return (
      <DialogContent sx={DialogModalStyles(theme)}>
        <div className="modal_content">
          {!!typeFlight && <FlightChipCollection flights={selectedFlights} />}

          <ModalTitle title="Add Selected Flights to an Existing Pairing"></ModalTitle>
          <ModalMessage message={"Find pairing from the menu below using its short code."}></ModalMessage>

          <DialogActions>
            <Grid container>
              <Grid container alignItems="center" wrap="nowrap" style={{ width: "auto" }}>
                <ShortCodeAssignment
                  className="inside_modal"
                  getSelectedShortCode={setSelectedShortCode}
                  hideInlineEdit={true}
                />
              </Grid>
              <Grid container alignItems="center" wrap="nowrap" style={{ width: "auto" }}>
                <ModalButton label="Cancel" handler={handleCancel}></ModalButton>
                <ModalButton
                  label="Add To Pairing"
                  handler={handleAssignToPairing}
                  disable={selectedEvents.length === 0 || !selectedShortCode}
                />
              </Grid>
            </Grid>
          </DialogActions>
        </div>
      </DialogContent>
    );
  } else {
    return null;
  }
};
